export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Cepa',
	plural_model_name_spanish: 'Cepas',
	create_model_name_spanish: 'Nueva Cepa',
	text_delete: 'la',
}